import { XML_DrawTri2PDF } from "./XML_DrawTri2PDF";
import { XML_DrawTri2PPT } from "./XML_DrawTri2PPT";
import { enumXMLType } from "../constants";

export function XML_DrawTri2(
  sx,
  sy,
  width,
  height,
  triColor,
  subTriColor,
  drawElement,
  layer,
  leftTri
) {
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF)
    XML_DrawTri2PDF(sx, sy, width, height, triColor, subTriColor, drawElement, layer, leftTri);
  else
    XML_DrawTri2PPT(
      sx,
      sy,
      width,
      height,
      triColor,
      subTriColor,
      drawElement,
      layer,
      0,
      0,
      "#000000",
      leftTri
    );
}
